/*
 * Bouncing Arrow JS Logic
*/

export default function ($, className) {
  $(function ($) {
    // Extension
    // https://stackoverflow.com/questions/3701311/event-when-user-stops-scrolling
    $.fn.scrollEnd = function (callback, timeout) {
      $(this).scroll(function () {
        var $this = $(this)
        if ($this.data('scrollTimeout')) {
          clearTimeout($this.data('scrollTimeout'))
        }
        $this.data('scrollTimeout', setTimeout(callback, timeout))
      })
    }

    // Definitions + Caches
    let page = $(window)
    let doc = $(document)
    let arrow = $(className)
    let duration = 3000 // 3000 = 3 sec
    let pageOffet = 600 // 600px

    // Detect if you're 200px from bottom
    function isPageEnd () {
      if ((doc.height() - page.height()) - page.scrollTop() < pageOffet) {
        return true
      }
      return false
    }

    // Scrolling - arrow hidden
    page.scroll(() => {
      arrow.removeClass('arrow-on')
    })

    // Stopped Scrolling
    page.scrollEnd(() => {
      // Show Bouncing Arrow
      if (!isPageEnd()) {
        arrow.toggleClass('arrow-on')
      }
    }, duration)
  })
}



// WEBPACK FOOTER //
// ./assets-src/js/component/bouncingArrow/index.js